"use strict";
exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/Observer.js
// module id = ../../../../rxjs/Observer.js
// module chunks = 18